import { render, staticRenderFns } from "./meta-data-widget.vue?vue&type=template&id=3477eba2&scoped=true"
import script from "./meta-data-widget.vue?vue&type=script&lang=js"
export * from "./meta-data-widget.vue?vue&type=script&lang=js"
import style0 from "./meta-data-widget.vue?vue&type=style&index=0&id=3477eba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3477eba2",
  null
  
)

export default component.exports